import api from './services/api';
import buildQuery from 'odata-query'

export const TOKEN_URL = '/appConfiguration'

// Pega o token do dia e atualiza
export async function renewMediaToken() {
    const response = await api.get(`${TOKEN_URL}/odata` + buildQuery({
        filter: {
            'isActive' : true
        },
        select: ['signature, TokenStreamming'],
        count: true
    }))
    if (response.data._count > 0) {
        const token = response.data.value[0].signature;
        localStorage.setItem('mediatoken', response.data.value[0].signature);
        localStorage.setItem('videotoken', response.data.value[0].tokenStreamming);
    }
    else {
        console.log("Erro, token de media não gerado hoje");
    }
}